import { createError } from './create-error';
export const MessageSubscribeError = createError('MessageSubscribeError', messageType => `Failed to subscribe to messages of type ${messageType}.`, {
  HANDSHAKE_FAILED: 'Connection unavailable. Handshake not finalized.',
  CONNECTION_UNAVAILABLE: "Connection wasn't opened"
});